module.exports = __webpack_public_path__ + "static/Rama Mamuaya-d9839e8c8b298a3e0e06e3816f057353.jpg";